// extracted by mini-css-extract-plugin
module.exports = {"food_box":"food_box-2XJB33yA"};